<template>
  <div>
    <div class="multiImgDiv">
      <div v-for="(item, index) in uploadedList" :key="index" class="multiImg">
        <img :src="item" alt=""/>
        <span class="editSpan">
          <span class="upload-preview" @click="showBigImg(item)"><i class="el-icon-zoom-in"></i></span>
          <span class="upload-delete" @click="deleteImg(index)" v-show="!disabled"><i class="el-icon-delete"></i></span>
        </span>
      </div>
    </div>
    <div :class="{'disabledUpload' : disabled}" class="multiUpload" v-show="isShow">
      <el-upload
        v-loading="loading"
        action="/zzgagent-pay-customer/merchant-stock/upload-pic"
        :show-file-list="false"
        accept="image/*"
        multiple
        :limit="realLimit"
        :auto-upload="false"
        list-type="picture-card"
        :data="otherData"
        :on-change="changeUploadImg"
        :on-exceed="uploadImgExceed"
        :file-list="filesList"
        :disabled="disabled">
        <slot> <i class="el-icon-plus"></i></slot>
      </el-upload>
    </div>
    <!--  图片放大弹窗    -->
    <el-dialog title="查看图片详情" :visible.sync="dialogBigImgVisible" width="800px" append-to-body>
      <img :src="bigImgSrc" alt="" class="bigImg">
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { uploadPic, singleTransPic } from '@/api/global'
export default {
  name: 'MultiUpload',
  props: {
    otherData: {
      type: Object,
      default: function () {
        return {
          picType: 'auxiliaryInfo'
        }
      }
    },
    // 是否可编辑
    disabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 4
    },
    value: {
      type: String,
      default: ''
    },
    valueName: {
      default: '',
      type: String
    },
    // 上传真实路由
    uploadedValue: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      loading: false,
      isShow: true,
      uploadedList: [], // 展示路径
      uploadedPathList: [], // 存储路径
      bigImgSrc: '',
      dialogBigImgVisible: false,
      filesList: [], // 上传的文件流列表
      initLength: 0// 初始化时已有图片张数
    }
  },
  watch: {
    value: {
      handler (val) {
        // 有初始化且有uploadedValue传参
        if (val && this.uploadedList.length === 0) {
          const that = this
          let list = []
          if (val.indexOf(',') >= 0) {
            list = val.split(',')
          } else {
            list.push(val)
          }
          this.initLength = list.length
          if (this.realLimit === 0) {
            this.isShow = false
          }
          this.uploadedList = []
          this.uploadedPathList = []
          if (this.uploadedValue) {
            let uploadedList = []
            const uploadedVal = this.uploadedValue
            if (uploadedVal.indexOf(',') >= 0) {
              uploadedList = uploadedVal.split(',')
            } else {
              uploadedList.push(uploadedVal)
            }
            // 如果不符合则按照value值遍历获取uploadedValue
            if (list.length === uploadedList.length) {
              this.uploadedPathList = list
              this.uploadedList = uploadedList
              return
            }
          }
          list.map((item) => {
            const param = qs.stringify({ path: item })
            singleTransPic(param).then(response => {
              if (response.error_code === '0') {
                const result = {
                  valueName: that.valueName,
                  path: response.data.path,
                  oldPath: item
                }
                that.uploadedPathList.push(response.data.path)
                that.uploadedList.push(response.data.show_path)
                that.$emit('init-upload', result)
              }
            })
          })
        }
      },
      immediate: true
    }
  },
  computed: {
    realLimit () {
      // 除去初始化时已有图片，实际可上传张数
      return this.limit - this.initLength
    }
  },
  methods: {
    // 上传图片
    async changeUploadImg (file, fileList) {
      this.filesList = fileList
      if (file.raw.size > 3 * 1024 * 1024) {
        this.$message({
          showClose: true,
          message: '图片大小不能超过3M',
          type: 'error'
        })
        this.filesList.pop()
      } else {
        this.loading = true
        const result = await this.upload(file)
        if (!result) {
          this.filesList.pop()
        }
      }
    },
    upload (file) {
      var that = this
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.readAsDataURL(file.raw)
        reader.onload = function (e) {
          var file = this.result
          file = file.split('base64,')
          var data = {
            base64pic: file[1],
            picType: 'auxiliaryInfo'
          }
          data = qs.stringify(data)
          uploadPic(data).then(data => {
            // 全部图片上传完毕再停止加载
            if (that.uploadedList.length - that.initLength === that.filesList.length - 1) {
              that.loading = false
            }
            if (data.error_code === '0') {
              resolve(true)
              that.$message({
                message: data.error_msg,
                type: 'success'
              })
              that.uploadedList.push(data.showPath)
              that.uploadedPathList.push(data.path)
              var result = Object.assign(data, {
                valueName: that.valueName
              })
              that.$emit('uploaded', result)
            } else {
              that.$message({
                message: data.error_msg,
                type: 'error'
              })
              resolve(false)
            }
          }).catch(err => {
            reject(err)
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          })
        }
      })
    },
    // 图片数量超出数量回调
    uploadImgExceed (files, fileList) {
      var that = this
      console.log(fileList)
      if (files.length > this.realLimit - fileList.length) {
        this.$message({
          showClose: true,
          message: '上传图片不能超过' + that.limit + '张',
          type: 'error'
        })
      }
      if (this.realLimit === fileList.length) {
        this.isShow = false
      }
    },
    // 图片放大
    showBigImg (src) {
      this.dialogBigImgVisible = true
      this.bigImgSrc = src
    },
    // 删除已上传的图片
    deleteImg (index) {
      var that = this
      this.$confirm('确认删除该图片？', '提示', {}).then(() => {
        var data = {
          path: that.uploadedPathList[index],
          valueName: that.valueName
        }
        that.uploadedPathList.splice(index, 1)
        that.uploadedList.splice(index, 1)
        // 如果删除的是初始就已有图片，fileList不删除
        if (index <= that.initLength - 1) {
          that.initLength--
        } else {
          that.filesList.splice(index, 1)
        }
        that.$emit('delete', data)
        this.isShow = true
      })
    }
  }
}
</script>

<style scoped>
    .multiImgDiv{
        float: left;
    }
    .multiImgDiv .multiImg{
        overflow: hidden;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        line-height: 148px;
        margin: 0 8px 8px 0;
        display: inline-block;
        position: relative;
    }
    .multiImgDiv img{
        width: 100%;
    }
    .multiUpload{
        display: inline-block;
    }
    .editSpan{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        cursor: default;
        text-align: center;
        color: #fff;
        opacity: 0;
        font-size: 20px;
        background-color: rgba(0,0,0,.5);
        transition: opacity .3s;
    }
    .editSpan span{
        display: none;
        cursor: pointer;
    }
    .multiImg:hover{
        box-shadow: 0 0 8px 0 rgba(232,237,250,.6),0 2px 4px 0 rgba(232,237,250,.5);
    }
    .multiImg:hover .editSpan{
        opacity: 0.8;
    }
    .multiImg:hover .editSpan span{
        display: inline-block;
    }
    img.bigImg {
        max-width: 100%;
        display: block;
    }
</style>
<style>
    .multiUpload.disabledUpload .el-upload--picture-card:hover{
        cursor: no-drop;
    }
</style>
